import { IImmigrationSnapshot, IPriorityDateDetailModel } from 'src/shared/types/Immigration';
import { createApiFetcher } from 'src/utils/ApiUtils';

export interface IImmigrationSnapshotsParams {
  beneId: string;
  countryCode: string;
}

const fetchData = createApiFetcher('immigration/');

export const getImmigrationSnapshots = (params: IImmigrationSnapshotsParams): Promise<IImmigrationSnapshot[]> =>
  fetchData<IImmigrationSnapshot[]>('snapshots', { ...params });

export const getPriorityDates = async (beneId: number | undefined): Promise<IPriorityDateDetailModel[]> =>
  fetchData<IPriorityDateDetailModel[]>(`priority-dates/${beneId}`);
